exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#search-component{height:auto;overflow-y:auto}#search-component .form-page-container .form-field-container{margin-top:7em!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/components/Search/search.css
// module id = 850
// module chunks = 0